import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import './Header.css';

function Topnav({ backButton }) {
    const navigate = useNavigate();
    const [dayhour, setDayhour] = useState("");
    // const name = localStorage.getItem('UserAlias');
    const name = localStorage.getItem('UserName');
    const [userImg, setUserImg] = useState(localStorage.getItem("UserImg"));

    const getHour = () => {
        const date = new Date();
        setDayhour(date.getHours());
    };

    const handleError = () => {
        setUserImg('../assets/person.PNG');
    };

    useEffect(() => {
        getHour();
        const hourInterval = setInterval(getHour, 60000);
        return () => clearInterval(hourInterval);
    }, []);

    return (
        <>
            {/* Fixed Header */}
            <header style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 5px', // Reduced side padding
                height: '60px',
                backgroundColor: '#f8f9fa',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                width: '100%',
                boxSizing: 'border-box'
            }}>
                {/* Left Section - Minimal padding */}
                <div style={{ 
                    flexShrink: 0,
                    width: '40px' // Fixed width for alignment
                }}>
                    {backButton ? (
                        <IconButton 
                            onClick={() => navigate(-1)}
                            aria-label="Go back"
                            style={{ padding: '4px', marginLeft: '-4px' }}
                        >
                            <ArrowBackIosIcon style={{ 
                                color: '#bd7925',
                                fontSize: '24px'
                            }} />
                        </IconButton>
                    ) : (
                        <IconButton style={{ padding: '2px' }}>
                            <img
                                src={userImg}
                                onError={handleError}
                                alt="User profile"
                                style={{
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '50%',
                                    objectFit: 'cover'
                                }}
                            />
                        </IconButton>
                    )}
                </div>

                {/* Center Section - Optimized for greeting text */}
                <div style={{
                    flex: 1,
                    minWidth: 0, // Allows text truncation
                    padding: '0 5px',
                    textAlign: 'center'
                }}>
                    <div style={{ 
                        display: 'inline-block',
                        maxWidth: '100%',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}>
                        <div style={{ 
                            fontSize: '15px',
                            lineHeight: '1.3',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            Hi {name}
                        </div>
                        <div style={{ 
                            fontSize: '14px',
                            color: '#bd7925',
                            fontWeight: 500,
                            lineHeight: '1.3',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            {dayhour < 12 ? 'Good Morning' : 
                             dayhour < 18 ? 'Good Afternoon' : 'Good Evening'}
                        </div>
                    </div>
                </div>

                {/* Right Section - Minimal padding */}
                <div style={{ 
                    flexShrink: 0,
                    width: '120px', // Fixed width for logo
                    textAlign: 'right',
                    paddingRight: '4px'
                }}>
                    <img
                        src="../assets/nlcc-logo.png"
                        alt="Organization Logo"
                        style={{
                            width: '120px',
                            height: '36px',
                            objectFit: 'contain'
                        }}
                    />
                </div>
            </header>

            {/* Header Spacer */}
            <div style={{ height: '60px', width: '100%' }} />
        </>
    );
}

export default Topnav;

// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import IconButton from '@mui/material/IconButton';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import './Header.css';

// function Topnav({ backButton }) {
//     const navigate = useNavigate();
//     const [dayhour, setDayhour] = useState("");
//     const name = localStorage.getItem('UserAlias');
//     const [userImg, setUserImg] = useState(localStorage.getItem("UserImg"));

//     // Get current hour for greeting
//     const getHour = () => {
//         const date = new Date();
//         setDayhour(date.getHours());
//     };

//     // Fallback for user image
//     const handleError = () => {
//         setUserImg('../assets/person.PNG');
//     };

//     // Effects
//     useEffect(() => {
//         getHour();
//         const hourInterval = setInterval(getHour, 60000); // Update hour every minute
        
//         return () => clearInterval(hourInterval);
//     }, []);

//     useEffect(() => {
//         if (!localStorage.getItem('UserAlias')) {
//             navigate('/');
//         }
//     }, [navigate]);

//     // Context menu prevention with proper cleanup
//     useEffect(() => {
//         const handleContextMenu = (e) => e.preventDefault();
//         document.addEventListener("contextmenu", handleContextMenu);
//         return () => document.removeEventListener("contextmenu", handleContextMenu);
//     }, []);

//     return (
//         <>
//             {/* Fixed Header */}
//             <header 
//                 className="topnav-header"
//                 style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     zIndex: 1000,
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     padding: '10px 15px',
//                     height: '60px',
//                     backgroundColor: '#f8f9fa',
//                     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//                     width: '100%',
//                     boxSizing: 'border-box'
//                 }}
//             >
//                 {/* Left Section - Back Button/User Image */}
//                 <div style={{ flex: '0 0 auto' }}>
//                     {backButton ? (
//                         <IconButton 
//                             onClick={() => navigate(-1)}
//                             aria-label="Go back"
//                             style={{ padding: '6px' }}
//                         >
//                             <ArrowBackIosIcon 
//                                 style={{ 
//                                     color: '#bd7925',
//                                     fontSize: '28px'
//                                 }} 
//                             />
//                         </IconButton>
//                     ) : (
//                         <IconButton aria-label="User profile" style={{ padding: '1px' }}>
//                             <img
//                                 src={userImg}
//                                 onError={handleError}
//                                 alt="User profile"
//                                 style={{
//                                     width: '40px',
//                                     height: '40px',
//                                     borderRadius: '50%',
//                                     objectFit: 'cover'
//                                 }}
//                             />
//                         </IconButton>
//                     )}
//                 </div>

//                 {/* Center Section - Greeting */}
//                 <div style={{
//                     flex: '1 1 auto',
//                     textAlign: 'center',
//                     padding: '0 10px',
//                     overflow: 'hidden'
//                 }}>
//                     <h6 style={{ 
//                         margin: 0,
//                         lineHeight: '1.3',
//                         whiteSpace: 'nowrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis'
//                     }}>
//                         Hi {name}
//                         <br />
//                         <span style={{ 
//                             fontSize: '0.9em', 
//                             color: '#bd7925',
//                             fontWeight: 500
//                         }}>
//                             {dayhour < 12 ? 'Good Morning' : 
//                              dayhour < 18 ? 'Good Afternoon' : 'Good Evening'}
//                         </span>
//                     </h6>
//                 </div>

//                 {/* Right Section - Logo */}
//                 <div style={{ flex: '0 0 auto' }}>
//                     <img
//                         src="../assets/nlcc-logo.png"
//                         alt="Organization Logo"
//                         style={{
//                             width: '140px',
//                             height: '40px',
//                             objectFit: 'contain'
//                         }}
//                     />
//                 </div>
//             </header>

//             {/* Header Spacer - Prevents content from being hidden */}
//             <div style={{ 
//                 height: '70px',
//                 width: '100%',
//                 flexShrink: 0 
//             }} />
//         </>
//     );
// }

// export default Topnav;


// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import IconButton from '@mui/material/IconButton';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import './Header.css';

// function Topnav({ backButton }) {
//     const navigate = useNavigate();
//     const [dayhour, setDayhour] = React.useState("");
//     const name = localStorage.getItem('UserAlias');
//     const [userImg, setUserImg] = useState(localStorage.getItem("UserImg"));

//     const getHour = () => {
//         const date = new Date();
//         const hour = date.getHours();
//         setDayhour(hour);
//         console.log(hour);
//     };

//     const handleError = () => {
//         setUserImg('../assets/person.PNG');
//     };

//     useEffect(() => {
//         getHour();
//     }, []);

//     useEffect(() => {
//         if (localStorage.getItem('UserAlias') === null) {
//             navigate('/');
//         }
//     }, [navigate]);

//     useEffect(() => {
//         const preventContextMenu = (e) => {
//             e.preventDefault();
//         };
        
//         document.addEventListener("contextmenu", preventContextMenu);
        
//         return () => {
//             document.removeEventListener("contextmenu", preventContextMenu);
//         };
//     }, []);

//     return (
//         <>
//             <div 
//                 className='header navbar-light bg-light'
//                 style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     zIndex: 1000,
//                     width: '100%',
//                     padding: '10px 15px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'space-between',
//                     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//                     height: '60px',
//                     boxSizing: 'border-box'
//                 }}
//             >
//                 {backButton ? (
//                     <IconButton 
//                         onClick={() => navigate(-1)} 
//                         style={{ padding: '8px' }}
//                     >
//                         <ArrowBackIosIcon 
//                             className='header_logo' 
//                             fontSize='large' 
//                             style={{ color: '#bd7925' }} 
//                         />
//                     </IconButton>
//                 ) : (
//                     <IconButton style={{ padding: '8px' }}>
//                         <img
//                             src={userImg}
//                             onError={handleError}
//                             alt='User profile'
//                             style={{
//                                 width: '43px',
//                                 height: '43px',
//                                 borderRadius: '43px',
//                                 minWidth: '43px',
//                                 objectFit: 'cover'
//                             }}
//                         />
//                     </IconButton>
//                 )}

//                 <div className="d-flex flex-column text-center flex-grow-0 mx-2">
//                     <h6 className="m-0 text-truncate" style={{ lineHeight: '1.2' }}>
//                         Hi {name}
//                         <br />
//                         {dayhour < 12 && (
//                             <span style={{ fontSize: '0.9em', color: '#bd7925' }}>
//                                 Good Morning
//                             </span>
//                         )}
//                         {dayhour >= 12 && dayhour < 18 && (
//                             <span style={{ fontSize: '0.9em', color: '#bd7925' }}>
//                                 Good Afternoon
//                             </span>
//                         )}
//                         {dayhour >= 18 && (
//                             <span style={{ fontSize: '0.9em', color: '#bd7925' }}>
//                                 Good Evening
//                             </span>
//                         )}
//                     </h6>
//                 </div>

//                 <div className="d-flex flex-shrink-0">
//                     <img
//                         src="../assets/nlcc-logo.png"
//                         alt="NLCC Logo"
//                         style={{
//                             width: '143px',
//                             height: '43px',
//                             objectFit: 'contain'
//                         }}
//                     />
//                 </div>
//             </div>
            
//             {/* Spacer div to prevent content from being hidden under the fixed header */}
//             <div style={{ height: '70px', width: '100%' }}></div>
//         </>
//     );
// }

// export default Topnav;


// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import IconButton from '@mui/material/IconButton';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import './Header.css';

// function Topnav({ backButton }) {
//     const navigate = useNavigate();
//     const [dayhour, setDayhour] = React.useState("");
//     const name = localStorage.getItem('UserAlias');
//     const [userImg, setUserImg] = useState(localStorage.getItem("UserImg"));

//     const getHour = () => {
//         const date = new Date();
//         const hour = date.getHours();
//         setDayhour(hour);
//         console.log(hour);
//     };

//     const handleError = () => {
//         setUserImg('../assets/person.PNG')
//     }

//     useEffect(() => {
//         getHour();
//     }, [])

//     useEffect(() => {
//         if (localStorage.getItem('UserAlias') === null) {
//             navigate('/');
//         }
//     }, [navigate]);

//     document.addEventListener(
//         "contextmenu", function(e) {
//             e.preventDefault();
//         }, false
//     );

//     return (
//         <div className='header navbar-light bg-light'>
//             {/* BEM Naming Convention */}
//             {backButton ? (
//                 <IconButton onClick={() => navigate(-1)}>
//                     <ArrowBackIosIcon className='header_logo' fontSize='large' />
//                 </IconButton>
//             ) : (
//                 <IconButton>
//                     <img
//                         src={userImg}
//                         // src="../assets/person.PNG"
//                         onError={handleError}
//                         alt=''
//                         className="nav-image"
//                         style={{
//                             width: '43px',
//                             height: '43px',
//                             borderRadius: '43px',
//                             minWidth: '43px'
//                         }}
//                     />
//                 </IconButton>
//             )}
//             <div className="d-flex flex-column text-center flex-grow-0 mx-2">
//                 <h6 className="m-0 text-truncate" style={{ lineHeight: '1.2' }}>
//                     Hi {name}
//                     <br />
//                     {dayhour < 12 && (
//                         <span className="text-warning" style={{ fontSize: '0.9em', color: '#bd7925' }}>
//                             Good Morning
//                         </span>
//                     )}
//                     {dayhour >= 12 && dayhour < 18 && (
//                         <span className="text-warning" style={{ fontSize: '0.9em', color: '#bd7925' }}>
//                             Good Afternoon
//                         </span>
//                     )}
//                     {dayhour >= 18 && (
//                         <span className="text-warning" style={{ fontSize: '0.9em', color: '#bd7925' }}>
//                             Good Evening
//                         </span>
//                     )}
//                 </h6>
//             </div>

//             <div className="d-flex flex-shrink-0">
//                 <img
//                     src="../assets/nlcc-logo.png"
//                     style={{
//                         width: '143px',
//                         height: '43px',
//                         objectFit: 'contain' // Ensure logo integrity
//                     }}
//                     alt="img"
//                 />
//             </div>
//         </div>
//     );
// }

// export default Topnav;